import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import {
    List,
    ListItem,
    Paper,
} from "@material-ui/core";
import { Coordinates } from "@optimusride/client-library/@types/grpc/common";
import { H1, H5 } from "../../common/styles/typography";
import { VehicleLocationAndStatus } from "../hooks/useVehicleFirestore";
import {
    SPACING_1, SPACING_8, SPACING_16, SPACING_12,
} from "../../common/styles/spacing";
import { FONT_0_75 } from "../../common/styles/fonts";
import VehicleStatusListItem from "./VehicleStatusListItem";

const StyledHeading = styled(H5)`
    margin-bottom: ${SPACING_8};
`;

const StyledGridHeadingContainer = styled.div`
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 2fr 1fr 1fr;
    align-items: center;

    margin-bottom: ${SPACING_8};
`;

const StyledGridHeading = styled(H1)`
    font-size: ${FONT_0_75};
    font-weight: bold;
    letter-spacing: ${SPACING_1};

    margin-top: ${SPACING_16};

    &:first-of-type {
        margin-left: ${SPACING_8};
    }
`;

const StyledVehicleList = styled(List)`
    overflow-y: auto;
    max-height: 33vh;
`;

const StyledVehicleListItem = styled(ListItem)`
    padding: 0;
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 2fr 1fr 1fr;

    margin-bottom: ${SPACING_16};

    &:hover {
        background: transparent;
    }
`;

const StyledPaper = styled(Paper)`
    border-radius: ${SPACING_12};
    padding: ${SPACING_12} 0 ${SPACING_12} ${SPACING_12};
`;

export default ({
    vehicleStatus,
    onClick,
    className,
}: {
    vehicleStatus: VehicleLocationAndStatus[];
    onClick: (latLon: Coordinates) => void;
    className?: string;
}) => {
    const { t } = useTranslation();

    return (
        <div className={className}>
            <StyledHeading>{t("home.vehicleStatus.vehicleStatus")}</StyledHeading>
            <StyledPaper>
                <StyledGridHeadingContainer>
                    <StyledGridHeading>{t("home.vehicleStatus.vehicleStatusID")}</StyledGridHeading>
                    <StyledGridHeading>{t("home.vehicleStatus.vehicleGear")}</StyledGridHeading>
                    <StyledGridHeading>{t("home.vehicleStatus.vehicleSpeed")}</StyledGridHeading>
                    <StyledGridHeading>{t("home.vehicleStatus.vehicleBattery")}</StyledGridHeading>
                    <StyledGridHeading>{t("home.vehicleStatus.vehicleInfo")}</StyledGridHeading>
                    <StyledGridHeading>{t("home.vehicleStatus.vehicleRoute")}</StyledGridHeading>
                </StyledGridHeadingContainer>
                <StyledVehicleList>
                    {vehicleStatus
                        .map(({ status, vehicle_id, coordinates }) => (
                            <StyledVehicleListItem
                                button
                                key={vehicle_id}
                                onClick={() => onClick(coordinates)}
                            >
                                <VehicleStatusListItem
                                    vehicleId={vehicle_id}
                                    status={status}
                                />
                            </StyledVehicleListItem>
                        ))}
                </StyledVehicleList>
            </StyledPaper>
        </div>
    );
};
